import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './Appointments.css';
const SERVER_URL = process.env.REACT_APP_TEST_API_URL ;

const Appointments = () => {

// Add useNavigate hook
const navigate = useNavigate();
// State for appointments 
const [appointments, setAppointments] = useState([]);
const [searchTerm, setSearchTerm] = useState('');

  // Load initial data (simulated)
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try{
      const response = await fetch(`${SERVER_URL}/api/appointment/getAll`);
      const appointments = await response.json();
      console.log(appointments)
      setAppointments(appointments); 
    }   
    catch(error) {
      console.error('There was a problem with the fetch operation:', error);
    };
  };

  // cancel Appointment
  const cancelAppointment = async(id) => {
    console.log(id)
    if (window.confirm('Are you sure you want to cancel this appointment?')) {
      await fetch(`${SERVER_URL}/api/appointment/cancelByAdmin/${id}`);
      fetchData()
    }
  };
  // approveAppointment
  const approveAppointment = async(id) => {
    console.log(id)
    if (window.confirm('Are you sure you want to change appointment status to Approved?')) {
      await fetch(`${SERVER_URL}/api/appointment/approvedByAdmin/${id}`);
      fetchData()
    }
  };
  // cancel Appointment
  const deleteAppointment = async(id) => {
    console.log(id)
    if (window.confirm('Are you sure you want to delete this appointment?')) {
      await fetch(`${SERVER_URL}/api/appointment/deleteByAdmin/${id}`);
      fetchData()
    }
  };

  // Add handleUserClick function
  const handleUserClick = (userId) => {
    if (userId) {
      navigate(`/user/${userId}`);
    }
  };
  // Filter appointments based on search term
  const filteredAppointments = appointments.filter(appointment => 
    appointment.service.toLowerCase().includes(searchTerm.toLowerCase()) ||
    appointment.status.toLowerCase().includes(searchTerm.toLowerCase()) 
  );

  return (
 
    <div className="user-management">
    
    <div className="search-bar">
        <input
        type="text"
        placeholder="Search appointments..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        />
    </div>
            
    <div className="users-table-container">
        <h3>Appointments</h3>
        {appointments.length > 0 ? (
        <table className="users-table">
            <thead>
            <tr>
                <th>ID</th>
                <th>Service</th>
                <th>Date</th>
                <th>Time Slot</th>
                <th>User Name</th>                    
                <th>Contact Number</th>
                <th>Status</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            {filteredAppointments.map((appointment,index) => (
                <tr key={appointment._id}>
                <td>{index+1}</td>
                <td>{appointment.service}</td>
                <td>{new Date(appointment.date).toLocaleDateString('en-GB', {day: '2-digit', month: '2-digit', year: '2-digit'})}</td>
                <td>{appointment.timeSlot}</td>
                <td>
                    {appointment.userId ? (
                    <span 
                        className="user-name-link" 
                        onClick={() => handleUserClick(appointment.userId._id)}
                    >
                        {appointment.userId.name || 'N/A'}
                    </span>
                    ) : 'N/A'}
                </td>
                <td>{appointment.userId?.contactNumber || 'N/A'}</td>
                <td>
                {appointment.status === "scheduled" ? (
                    <span className="status-badge status-scheduled">Scheduled</span>
                ) : appointment.status === "cancelled" ? (
                    <span className="status-badge status-cancelled">Cancelled</span>
                ) : appointment.status === "approved" ? (
                    <span className="status-badge status-complete">Approved</span>
                ) : (
                    <span className="status-badge">{appointment.status}</span>
                )}
                </td>
                <td className="actions-cell">
                <button
                    className="btn-complete"
                    onClick={() => approveAppointment(appointment._id)}
                >
                    Approve
                </button>
                <button
                    className="btn-cancel"
                    onClick={() => cancelAppointment(appointment._id)}
                >
                    Cancel
                </button>
                <button
                    className="btn-delete"
                    onClick={() => deleteAppointment(appointment._id)}
                >
                    Delete
                </button>
                </td>
            </tr>
            ))}
            </tbody>
        </table>
        ) : (
        <p className="no-users">No appointments found.</p>
        )}
    </div>
    </div>
       
  );
};

export default Appointments;